const PLATFORMS = {
  IOS: 'ios',
  ANDROID: 'android',
  _IOS: 'IOS',
  _ANDROID: 'ANDROID'
}

export default PLATFORMS
